import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-opi',
  templateUrl: './opi.component.html',
  styleUrls: ['./opi.component.scss'],
})


export class OpiComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['opi'];
  }

}


